<template>
    <print-layout>
        <div class="print-container">
            <div class="text-center mb-2">
                <div class="text-2xl font-bold">{{ formatTitle(report) }} Report</div>
                <div>{{ formatDate(from) }} - {{ formatDate(to) }}</div>
            </div>

            <div class="rounded-t overflow-hidden border border-b-0">
                <!-- Report Vue Components -->
                <outlet-sales v-if="report === 'outlet_sales'" :data="data" />
                <item-sales v-if="report === 'item_sales'" :data="data" />
                <item-pick-zones v-if="report === 'item_pick'" :data="data" />
                <customer-sales v-if="report === 'customer_sales'" :data="data" :show_chart="true" />
                <promo-codes v-if="report === 'promo_codes'" :data="data" />
                <referral-campaign v-if="report === 'referral_campaign'" :data="data"/>
            </div>
        </div>
    </print-layout>
</template>

<script>
import PrintLayout from '@/Layouts/PrintLayout.vue';
import { DateTime } from "luxon";

// Reports
import OutletSales from '@/Pages/Reports/Retail/OutletSales';
import ItemSales from '@/Pages/Reports/Retail/ItemSales';
import ItemPickZones from '@/Pages/Reports/Retail/ItemPickZones';
import CustomerSales from '@/Pages/Reports/Retail/CustomerSales';
import PromoCodes from '@/Pages/Reports/Retail/PromoCodes';
import ReferralCampaign from '@/Pages/Reports/Retail/ReferralCampaign';

export default {
    components: {
        PrintLayout,
        OutletSales,
        ItemSales,
        ItemPickZones,
        CustomerSales,
        PromoCodes,
        ReferralCampaign,
    },

    props: ['report', 'from', 'to', 'data'],

    methods: {
        formatDate(date) {
            return DateTime.fromISO(date).toFormat('MMM d, yyyy');
        },
        formatTitle(string) {
            return string.split('_').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ');
        }
    },

    mounted () {
        console.log('this.report, this.from, this.to, this.data :>> ', this.report, this.from, this.to, this.data);
        window.print();

        window.onafterprint = function() {
            window.close();
        };
    }
}

</script>

<style>
    body {
        font-size: 90%;
        height: 100%;
    }

    table {
        width: 100%;
    }

    table td {
        -webkit-print-color-adjust: exact;
    }

    .page-break {
        page-break-after: always;
    }

    @media screen {
        .print-container {
            display: none;
        }
    }
</style>